import filePreviewTemplate from './file-preview.html';

export default class FilePreviewPdfComponent {
  constructor() {
    this.template = filePreviewTemplate;
    this.bindings = {
      filePath: '<',
      previewType: '<',
      credentials: '<',
      fileName: '<',
      hidePreview: '&',
    };
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/modules/utils/file-preview/components/file-preview/file-preview-component.js